export default __webpack_public_path__ + "static/media/39.3e19926f.jpg";